import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ITimezone, TIMEZONES } from '../../../shared/constants/timezones';

@Component({
  selector: 'app-publish-time',
  templateUrl: './publish-time.component.html',
  styleUrls: ['./publish-time.component.scss'],
})
export class PublishTimeComponent {
  @Input() publishTimeControl: FormControl;
  @Input() timezoneControl: FormControl;
  @Input() showPublishTimeControl: FormControl;
  @Input() isExpandedByDefault = false;
  @Input() isExpandable = true;
  @Input() timezones: ITimezone[];
  @Input() enableAutomatic: boolean = true;

  setTime: boolean = false;

  getTimezoneDisplayText(timezone: string) {
    if (timezone) {
      return TIMEZONES.find((t) => t.windowsTimezoneId === timezone)
        .displayText;
    }
  }
}
